import { render } from "./site-search.vue?vue&type=template&id=631ad057"
import script from "./site-search.vue?vue&type=script&lang=js"
export * from "./site-search.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__